import { observer } from "mobx-react-lite";

import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { useStore } from "@/store";

export const MobileDownloadButton = observer(function MobileDownloadButton() {
  const { view } = useStore();

  const handleDownloadButtonClick = () => {
    view.isMobileMenuVisible = false;
    view.isMobileDownloadVisible = !view.isMobileDownloadVisible;
  };

  return (
    <Sidebar.Button
      onClick={handleDownloadButtonClick}
      icon={
        view.isMobileDownloadVisible ? (
          <div className="rounded-8 flex w-8 h-8 -m-1 bg-blue-100 dark:bg-blue-900">
            <Icon name="download/Download" className="m-auto w-7 h-7 [&>path]:stroke-blue-500" />
          </div>
        ) : (
          <Icon name="download/Download" className="m-auto w-7 h-7" />
        )
      }
    />
  );
});
